import config from 'lib/config';
import authorizedFetch from '../authorizedFetch';

async function removeFavorite(id: number): Promise<void> {
  return authorizedFetch(`${config.coreApiUrl}/favorites/${id}`, { method: 'DELETE' });
}

export default removeFavorite;
